import React from "react";
import { Box } from "@mui/material";

type Props = {
  /** When true the children fade/slide in; when false they're hidden but
   *  still occupy layout space (so the container size stays stable). */
  visible: boolean;
  children: React.ReactNode;
  /** Optional delay (ms) so a group of elements can stagger in. */
  delayMs?: number;
};

/**
 * Lightweight reveal wrapper for the consultation step flow. Keeps its child
 * mounted and in-layout at all times (so advancing substeps never resizes the
 * surrounding card) and animates opacity + a small upward slide when toggled
 * visible. Hidden children are non-interactive.
 */
const Reveal: React.FC<Props> = ({ visible, children, delayMs = 0 }) => (
  <Box
    sx={{
      opacity: visible ? 1 : 0,
      transform: visible ? "translateY(0)" : "translateY(8px)",
      transition: `opacity 350ms ease ${delayMs}ms, transform 350ms ease ${delayMs}ms`,
      pointerEvents: visible ? "auto" : "none",
    }}
  >
    {children}
  </Box>
);

export default Reveal;
